export default "__VITE_ASSET__C2HO95ui__"